<template>
    <div>
      <v-progress-circular v-show="saveLoading"
        indeterminate
        color="primary"
      ></v-progress-circular>

        <v-layout row wrap type="flex" justify="center" style="margin-bottom: 10px;"
                v-if="(uploadedFiles.length > 0 || (getUserImageList.length > 0)) &&
                 ((isOfficial === false || !isOfficial) && showUploadButton === true)">
            <v-flex :lg="6" :md="8" :xs="24" :sm="24">
                <v-btn style="font-size: 32px;" class="primary" dark text
                            @click="save">上傳</v-btn>
            </v-flex>
        </v-layout>
        <v-layout  row wrap style="margin-left: 0;">
            <v-flex>
                <div class="dropbox" v-if="isOfficial && zipUpload">
                    <input type="file" ref="file" multiple :name="uploadFieldName"
                           @change="filesChange($event.target.name, $event.target.files);"
                           accept=".zip" class="input-file">
                    <p>
                        將壓縮檔.zip檔拖到此處<br> 或點擊上傳
                    </p>
                </div>
                <div class="dropbox" v-else>
                  <input type="file" ref="file" multiple :name="uploadFieldName"
                         @change="filesChange($event.target.name, $event.target.files);"
                         accept="image/*,.pdf" class="input-file">
                  <p>
                    將圖片或PDF(一張或多張)拖到此處<br> 或點擊上傳
                  </p>
                </div>
            </v-flex>

            <v-flex v-if="uploadedFiles.length > 0"
                    class="margin-bottom"
                    v-for="(file, index) in uploadedFiles"
                    :key="`${file.name}_${index}`">
                <div class="imgBox" :key="`${file.name}_${index}`">
                    <img class="image-view" v-if="file.name.toLowerCase().indexOf('.pdf') === -1 && file.name.toLowerCase().indexOf('.zip') === -1" :src="file.image" />
                    <v-layout>
                        <v-flex md8 style="padding-left: 0.5rem; ">
                            <span class="image-title">{{file.name}}</span>
                        </v-flex>
                        <v-flex md4>
                          <v-btn type="danger" size="small" style="margin: 5px;"
                            @click="removeUploadImage(file.name)">刪除</v-btn>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>

            <v-flex v-if="getUserImageList.length > 0"
                    class="margin-bottom"
                    v-for="(imgItem, index) in getUserImageList"
                    :key="`${imgItem.imageName}_${index}`">
                <div class="imgBox"  v-if="imgItem.data">
                    <img class="image-view"  :src="getImageData(imgItem)" :alt="imgItem.imageName">
                    <v-layout row wrap>
                        <v-flex md8 style="padding-left: 0.5rem;">
                            <span class="image-title">{{imgItem.imageName}}</span>
                        </v-flex>
                        <v-flex md4><v-btn class="danger" size="small" style="margin: 5px;"
                           @click="removeImage(imgItem.imageName)">刪除
                        </v-btn>
                        </v-flex>
                    </v-layout>
                </div>
                <div v-else-if="imgItem.imageName" class="imgBox" :key="getUrl(imgItem.imageName, index)">
                    <img class="image-view" :ref="`${itemDetail.userId}${index}`"
                         :src="imgUrl" :alt="imgItem.imageName" @click="openURL(imgUrl)">
                    <v-layout row wrap>
                        <v-flex md8 style="padding-left: 0.5rem;">
                            <span class="image-title">{{imgItem.imageName}}</span>confirmImages
                        </v-flex>
                        <v-flex md4><v-btn class="danger" size="small" style="margin: 5px;"
                              @click="removeImage(imgItem.imageName)">刪除</v-btn>
                        </v-flex>
                    </v-layout>
                </div>
                <div v-else class="imgBox" :key="imgItem">
                  <img class="image-view"  :src="imgItem" :alt="imgItem" @click="openURL(imgItem)">
                  <v-layout >
                    <v-flex md4><v-btn class="danger" size="small" style="margin: 5px;"
                                               @click="removeImage(imgItem)">刪除</v-btn>
                    </v-flex>
                  </v-layout>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row wrap v-if="(uploadedFiles.length > 0 || (getUserImageList.length > 0))
                && ((isOfficial === false || !isOfficial)
                && showUploadButton === true)">
          <v-flex lg3 md3 xs12 sm12 offset-xs2 offset-md2 >
            <v-btn style="font-size: 32px;" class="primary" dark text @click="save">上傳</v-btn>
          </v-flex>
        </v-layout>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AttachmentModel from '../models/AttachmentModel';

export default {
  props: ['itemDetail', 'uploadType' , 'isOfficial', 'showUploadButton', 'zipUpload'],
  name: 'UploadView',
  data() {
    return {
      attachmentFiles : [],
      uploadedFiles: [],
      uploadFieldName: 'photos',
      imageInfo: {
        imageName: '',
        sort: 0,
      },
      saveLoading: false,
      loadingText: '上傳中...',
      imgUrl: 'http://fakeimg.pl/350x200/?text=Loading&font=lobster',
      count: 0,
    };
  },
  watch:{
    zipUpload(value){
      if (this.zipUpload !== value){
        this.$refs.file.value = null;
      }
    }
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    getUserImageList() {
      // console.log(`image list == ${this.uploadType} , ${JSON.stringify(this.itemDetail)}`);
      if (this.itemDetail.imageList) {
        const list = this.itemDetail.imageList.slice();
        return list;
        // return list.filter(image => image.type === this.uploadType || image.type === 'add' );
      }
      return [];
    },
  },
  methods: {
    ...mapActions(['updateData', 'getImageUrl', 'removeData', 'uploadImageData', 'saveFinanceCreditData', 'saveAttachmentFile' ]),
    insertImage() {
      if (this.imageInfo.imageName.length < 1) {
        this.$message({
          message: '請選擇圖片',
          type: 'warning',
        });
        return;
      }
      if (!this.itemDetail.imageList) {
        this.itemDetail.imageList = [];
      }
      const isDuplicate = this.itemDetail.imageList.slice()
        .some(item => item.imageName === this.imageInfo.imageName);
      if (isDuplicate) {
        this.$message({
          message: '重複',
          type: 'warning',
        });
      } else {
        Object.assign(this.imageInfo, {
          sort: this.itemDetail.imageList.length,
        });
        this.itemDetail.imageList.splice(this.itemDetail.imageList.length, 1,
          JSON.parse(JSON.stringify(this.imageInfo)));
        Object.assign(this.imageInfo, {
          imageName: '',
        });
      }
    },
    removeImage(imgName) {
      this.itemDetail.imageList.forEach((item, index) => {
        if (item.imageName === imgName) {
          this.itemDetail.imageList.splice(index, 1);
        } else if (item === imgName) {
          this.itemDetail.imageList.splice(index, 1);
        }
      });
      this.saveFinanceCreditData(this.itemDetail);
    },
    removeUploadImage(imgName) {
      const copy = JSON.parse(JSON.stringify(this.uploadedFiles));
      copy.forEach((item, index) => {
        if (item.name === imgName) {
          this.uploadedFiles.splice(index, 1);
        }
      });
      console.log(`uploadedFiles == ${this.uploadedFiles.length}`);
      if (this.uploadedFiles.length === 0){
        this.$refs.file.value = null;
      }
      if (this.isOfficial === true){
        this.$emit('onRemoveFile', this.attachmentFiles);
      } else {
        this.$emit('onRemoveFile', this.uploadedFiles);
      }

    },
    getImageData(item) {
      console.log(`getImageData === ${JSON.stringify(item)}`);
      if (item) {
        return item.data;
      }
      return 'http://fakeimg.pl/350x200/?text=Error&font=lobster';
    },
    getUrl(imgName, index) {
      if (!imgName){
        return
      }
      const path = `${this.itemDetail.caseId}/${imgName}`;

      this.getImageUrl(`userImages/${path}`).then((url) => {
        this.$refs[`${this.itemDetail.caseId}${index}`][0].src = url;
      }).catch(() => {
        this.$refs[`${this.itemDetail.caseId}${index}`][0].src = 'http://fakeimg.pl/350x200/?text=Error&font=lobster';
      });
      return index;
    },
    async save() {
      this.loadingText = '上傳中...';
      console.log(`this.uploadedFiles.length === ${this.uploadedFiles.length}`);
      if (this.uploadedFiles && this.uploadedFiles.length > 0) { // 是否有圖片要上傳
        this.saveLoading = true;
        let uploadCount = 0;

        for (let file of this.attachmentFiles) {
            await this.saveAttachmentFile(file);
            // console.log(`save ${JSON.stringify(response)}`);
        }
        this.uploadedFiles.forEach((item) => {
          // console.log(`user === ${this.itemDetail.caseId} image = ${item.image}`);
          const path = `${this.itemDetail.caseId}/${item.name}`;
          this.$store.dispatch('uploadImageData', {
            name: `caseImages/${path}`,
            image: item.image,
          }).then((response) => {
            console.log(`uploadImageData success ${JSON.stringify(response)}`);
            uploadCount += 1;

            // 加入新圖資料
            if (!this.itemDetail.imageList) {
              this.itemDetail.imageList = [];
              const newImage = { imageName: item.name,
                type: this.uploadType,
                sort: 0,
                data: response };
              this.itemDetail.imageList.push(newImage);
            } else {
              const newImage = { imageName: item.name,
                type: this.uploadType,
                sort: this.itemDetail.imageList.length,
                data: response };
              this.itemDetail.imageList.push(newImage);
            }
            // 處理完成更新資料
            if (this.uploadedFiles.length === uploadCount) {
              this.saveUser();
            }
          }, (error) => {
            console.log(`uploadImageData error ${JSON.stringify(error)}`);
            uploadCount += 1;
            if (this.uploadedFiles.length === uploadCount) {
              this.saveLoading = false;
            }
          });
        });
      } else {
        this.saveUser();
      }
    },
    saveUser() {
      // 圖片排序
      if (this.itemDetail.imageList && this.itemDetail.imageList.length > 0) {
        this.itemDetail.imageList.slice().sort((p1, p2) => p1.sort - p2.sort);
      }

      this.saveFinanceCreditData(this.itemDetail);
      this.saveLoading = false;
      this.uploadedFiles = [];
      this.$emit('onFinishUpload', this.itemDetail);
    },
    filesChange(fieldName, fileList) {
      console.log(fieldName);
      const files = Object.values(this.$refs.file.files);
      console.log('== files4 ==');

      console.log(fileList.length);
      console.log(files);
      console.log('== files5 ==');
      // handle file changes
      const formData = new FormData();
      if (!fileList.length) return;

      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        // eslint-disable-next-line
        .map((i ,x) => {
          formData.append(fieldName, fileList[x], fileList[x].name);

          const file = { name: fileList[x].name, image: fileList[x],
            size: fileList[x].size, type: fileList[x].type };

          this.createImage(i, file , fileList.length - 1);
        });
    },
    createImage(i , file, total) {
      console.log('== files6 ==');
      const reader = new FileReader();
      const fileName = file.name;
      console.log(`=== createImage fileName === ${fileName} `);
      reader.onload = (e) => {

        const image = e.target.result;
        console.log(`=== createImage === \n ${image}`);
        const filItem = { name:fileName, image };
        console.log(`=== createImage === `);
        this.uploadedFiles.push(filItem);

        if (this.itemDetail.caseId && this.itemDetail.caseId !== '') {
          const newFileName = `${new Date().getTime()}.${this.getFileType(file.type)}`;
          let attachmentItem = new AttachmentModel();
              attachmentItem.caseId = this.itemDetail.caseId;
              attachmentItem.file_index = i;
              attachmentItem.file_body_encode = image.split(',')[1];
              attachmentItem.file_size = `${file.size}`;
              attachmentItem.content_type = this.getFileType(file.type);
              attachmentItem.name = newFileName;
              attachmentItem.file_body_full = image;
          this.attachmentFiles.push(attachmentItem);

          console.log(`isFinanceOfficial ===`);
          console.log(`confirmOfficeImages count ===`);
          if (i === total) {
            console.log(`this.isFinanceOfficial ${this.isOfficial}`);
            if (this.isOfficial === true){
              this.confirmOfficeImages();
            } else {
              this.confirmImages();
            }
          }
        }
      };
      reader.readAsDataURL(file.image);
    },
    getFileType(type) {
      const name = type.toLowerCase();
      if (name.indexOf('jpeg') > -1 || name.indexOf('jpg') > -1) {
        return 'jpg';
      }
      if (name.indexOf('png') > -1) {
        return 'png';
      }
      if (name.indexOf('pdf') > -1) {
        return 'pdf';
      }
      return 'zip';
    },
    confirmOfficeImages(){
      console.log(`confirmOfficeImages count === ${ this.attachmentFiles.length }`);
      this.$emit('confirmOfficeImages', this.attachmentFiles);
    },
    confirmImages(){
      this.$emit('confirmImages', this.uploadedFiles);
    },
    openURL(url){
      window.open(url, '_blank')
    }
  },
};

</script>

<style scoped>
    .imgBox {
        box-shadow: 4px 4px 12px -2px rgba(20%,20%,40%,0.5);

    }

    .image-view {
        width: 100%;
        height: 180px;
        object-fit: scale-down;
    }

    .image-title {

        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
        display: block;
        overflow: hidden
    }


    .dropbox {
        outline: 2px dashed grey; /* the dash box */
        outline-offset: -10px;
        background: white;
        color: dimgray;
        padding: 10px 10px;
        min-height: 200px; /* minimum height */
        position: relative;
        cursor: pointer;
    }

    .input-file {
        opacity: 0; /* invisible but it's there! */
        width: 100%;
        height: 200px;
        position: absolute;
        cursor: pointer;
    }

    .dropbox:hover {
        background: white;
    }

    .dropbox p {
        font-size: 1.2em;
        text-align: center;
        padding: 50px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/UploadView.vue